import { FullAuditable, HasId, PathBuilder, HttpMethod, ApiRoute } from '../common';

export interface DeviceSetting extends HasId, FullAuditable {
    deviceId: number;
    userId: number;
    notificationsEnabled: boolean;
    scheduledPostNotificationEnabled: boolean;
    agencyNotificationsEnabled: boolean;
}

export interface UpdateDeviceSettings {
    notificationsEnabled?: boolean;
    scheduledPostNotificationEnabled?: boolean;
    agencyNotificationsEnabled?: boolean;
}

export interface BaseDeviceSettingParams {
    uid: string;
}

const DEVICE_SETTINGS_API_ROOT = <T extends BaseDeviceSettingParams>(path: PathBuilder<T>) =>
    path.literal('devices').param('uid').literal('settings');

export const DeviceSettingsApi = {
    getDeviceSettings: new ApiRoute<DeviceSetting, BaseDeviceSettingParams, void, void>(
        HttpMethod.Get,
        DEVICE_SETTINGS_API_ROOT,
    ),
    updateDeviceSettings: new ApiRoute<DeviceSetting, BaseDeviceSettingParams, UpdateDeviceSettings, void>(
        HttpMethod.Patch,
        DEVICE_SETTINGS_API_ROOT,
    ),
};
